import React from 'react';
import { motion } from 'framer-motion';
import { CARD } from '../../config/designTokens';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverEffect?: boolean;
}
/**
 * Card primitive.
 *
 * NOTE on bg-overrides (parent portal audit v1.8, P-UI-1):
 * Tailwind's compiled CSS emits utilities alphabetically within the same
 * category, so a `bg-white` written in `CARD.base` ends up LATER in the
 * stylesheet than any `bg-emerald-600` / `bg-emerald-50` / `bg-rose-50/40`
 * passed via `className`. The browser then applies `bg-white` and the
 * "intended" tint silently disappears — most visibly on the parent-portal
 * hero ("Hoe gaat het met Noor?"), the VoortgangPage growth-story banner,
 * and the ComparePage emerald hero.
 *
 * Fix: if the caller's `className` already contains a `bg-` utility, we
 * strip `bg-white` from `CARD.base` so the caller wins.
 */
export function Card({
  children,
  className = '',
  onClick,
  hoverEffect = false
}: CardProps) {
  const callerProvidesBg = /(^|\s)bg-(?!opacity-)/.test(className);
  const base = callerProvidesBg ? CARD.base.replace(/\bbg-white\b/, '') : CARD.base;
  return <motion.div className={`
        ${base} overflow-hidden
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} whileHover={hoverEffect && onClick ? {
    y: -4,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    borderColor: CARD.hoverBorder
  } : {}} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 25,
    duration: 0.2
  }} data-id="element-2742" data-mp="1kfffxrpjuxjk">
      {children}
    </motion.div>;
}